import React, { useEffect, useState } from "react";
import Header from "../../Components/Header";
import { useLocation, useNavigate } from "react-router-dom";
import { leftArrow } from "../../common/Assets/imgs";
import { post, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import toast from "react-hot-toast";


const formatDateTime = (dateString) => {
  const date = new Date(dateString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;

  return `${day}-${month}-${year}, ${hours}:${minutes} ${ampm}`;
};

const BookingRequest = () => {
  const location = useLocation();
  console.log("bookingRequest", location);
  const navigation = useNavigate();
  const [isEdit, setIsEdit] = useState(false);
  const [popup, setPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const step = location?.state?.step;
  const tabNamee = location?.state?.tabName;
  console.log('tabNamee',tabNamee);
  


  const data = location?.state?.datas;
  console.log("data", data);
  const type = location?.state?.type;
  console.log("type", type);

  useEffect(() => {
    sessionStorage.setItem('bookingdata', JSON.stringify(data));
    sessionStorage.setItem('tabname', tabNamee);
  }, [data]);

  const [form, setForm] = useState({
    trip_id: "",
    user_name: "",
    mobile: "",
    user_type: "",
    pickup: "",
    pickupdate:"",
    drop: "",
    vehicle_type: "",
    vehicle_count: "",
    max_volume: "",
    start_time: "",
    total_amount: "",
    paid_amount: "",
    balance_amount: "",
    reason: '',
    status: '',
    cancelled_reason: '',
    cancelled_at:'',

  });

  useEffect(() => {
    if (data) {
      setForm({
        trip_id: data?.trip_code || "",
        user_name: data?.user_name || "",
        mobile: data?.user_mobile || "",
        user_type: data?.user_special_user === "False" || "",
        pickup: data?.trip_pickup || "",
        pickupdate:data?.pickup || "",
        drop: data?.trip_drop || "",
        vehicle_type: data?.vehicle_type || "",
        vehicle_count: data?.vehicle_count || "",
        max_volume: data?.vehicle_max_ton || "",
        start_time: data?.created_at || "",
        total_amount: data?.total_amount || "",
        paid_amount: data?.paid_amount || "",
        balance_amount: data?.balance_amount || "",
        status: data?.status || "",
        cancelled_reason: data?.cancelled_reason || "",
        cancelled_at: data?.cancelled_at || "",
      });
    }
  }, [data]);

  const handleChange = (key, value) => {
    setForm({ ...form, [key]: value });
  };

  const handleSave = async () => {
    const payload = new FormData();
    payload.append("persion_code", form.persion_code);
    payload.append("name", form.name);
    payload.append("email", form.email);
    payload.append("mobile", form.mobile);

    try {
      if (type === "add") {
        const res = await post(URLS.CONTACTS_ADD, payload);
        if (res?.status === "success") {
          toast.success(res.message || "Added successfully");
          navigation(-1);
        }
      } else {
        const res = await put(`${URLS.CONTACTS__EDIT}${data?.id}/`, payload);
        if (res?.status === "success") {
          toast.success(res.message || "Updated successfully");
          navigation(-1);
        }
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const canceltrip = async () => {
    try {
      const res = await post(`${URLS.BOOKINGS_CANCEL}${data.id}/`, { cancelled_reason: form?.reason })
      console.log('res', res);
      if (res?.status === "success") {
        toast.success(res?.message);
        setPopup(false);
        setForm({
          reason: ''
        });
        navigation(-1);
      }

    }
    catch (err) {
      console.log('err', err);
    }
  }

  return (
    <div>
      <Header />
      <div className="add-admin-container">
        {/* Header */}
        <div onClick={() => navigation(-1)} className="admin-header">
          <img src={leftArrow} className="back-icon-arrow" />
          <h2>{tabNamee}</h2>
        </div>
        {/* <div className="image-list">
                             {image ? (
                                 <div className="image-card">
                                     <img src={image.preview} alt="vehicle" />
         
                                     <button className="remove-btn" onClick={removeImage}>
                                         ×
                                     </button>
                                 </div>
                             ) : (
                                 <label className="upload-box">
                                     <img src={defaultImg} className="imageSize" alt="vehicle" />
                                     <input
                                         type="file"
                                         accept="image/*"
                                         onChange={handleImageChange}
                                         hidden
                                         disabled={!isEdit}
         
                                     />
                                 </label>
                             )}
                         </div> */}
        {/* Form */}
        <div className="admin-form">
          {/* Row 1 */}
          <div className="form-groups">
            <label>Trip ID</label>
            <input
              type="text"
              className=""
              value={form.trip_id}
              onChange={(e) => handleChange("persion_code", e.target.value)}
              readOnly={!isEdit}
            />
          </div>

          <div className="form-groups">
            <label>User Name</label>
            <input
              type="text"
              value={form.user_name}
              onChange={(e) => handleChange("name", e.target.value)}
              readOnly={!isEdit}
            />
          </div>

          {/* Row 2 */}
          <div className="form-groups">
            <label>Mobile Number</label>
            <input
              type="text"
              value={form.mobile}
              onChange={(e) => handleChange("mobile", e.target.value)}
              readOnly={!isEdit}
            />
          </div>
          <div className="form-groups">
            <label>User Type</label>
            <input
              type="text"
              value={form.user_type ? "Normal user" : "special user"}
              onChange={(e) => handleChange("email", e.target.value)}
              readOnly={!isEdit}
            />
          </div>
          {/* Row 3 */}
          <div className="form-groups">
            <label>Loading Location</label>
            <textarea
              type="text"
              rows={4}
              value={form.pickup}
              onChange={(e) => handleChange("mobile", e.target.value)}
              readOnly={!isEdit}
            />
          </div>
          <div className="form-groups">
            <label>Drop Location</label>
            <textarea
              type="text"
              rows={4}
              value={form.drop}
              onChange={(e) => handleChange("email", e.target.value)}
              readOnly={!isEdit}
            />
          </div>
          {/* Row 4 */}
          <div className="form-groups">
            <label>Vehicle Type</label>
            <input
              type="text"
              value={form.vehicle_type}
              onChange={(e) => handleChange("mobile", e.target.value)}
              readOnly={!isEdit}
            />
          </div>
          <div className="form-groups">
            <label>Vehicle Count</label>
            <input
              type="text"
              value={form.vehicle_count}
              onChange={(e) => handleChange("email", e.target.value)}
              readOnly={!isEdit}
            />
          </div>
          {/* Row 5 */}
          <div className="form-groups">
            <label>Max Volume</label>
            <input
              type="text"
              value={form.max_volume}
              onChange={(e) => handleChange("mobile", e.target.value)}
              readOnly={!isEdit}
            />
          </div>
          <div className="form-groups">
            <label>Trip Start Date & Time</label>
            <input
              type="text"
              value={formatDateTime(form.start_time)}
              onChange={(e) => handleChange("email", e.target.value)}
              readOnly={!isEdit}
            />
          </div>
          {/* Row 6 */}
          <div className="form-groups">
            <label>Total Amount</label>
            <input
              type="text"
              value={form.total_amount}
              onChange={(e) => handleChange("mobile", e.target.value)}
              readOnly={!isEdit}
            />
          </div>
          <div className="form-groups">
            <label>Paid Amount</label>
            <input
              type="text"
              className={`${form.paid_amount ? "text-success fw-semibold" : ""}`}
              value={form.paid_amount}
              onChange={(e) => handleChange("email", e.target.value)}
              readOnly={!isEdit}
            />
          </div>
          {/* Row 7 */}
          <div className="form-groups">
            <label>Remaining Amount</label>
            <input
              type="text"
              className={`${form.balance_amount ? "text-danger fw-semibold" : ""}`}
              value={form.balance_amount}
              onChange={(e) => handleChange("mobile", e.target.value)}
              readOnly={!isEdit}
            />
          </div>
          {/* assigned */}
          {

          }
          <div className="form-groups">
            <label>Pick up Date & Time</label>
            <input
              type="text"
              value={formatDateTime(form.pickupdate)}
              onChange={(e) => handleChange("email", e.target.value)}
              readOnly={!isEdit}
            />
          </div>

          {
           ( step === 5 || step === 3 || step === 4 || tabNamee === "Cancelled" || tabNamee === "Ongoing")  && (
            
              <div className="form-groups">
                <label>Status</label>
                <input
                  type="text"
                  className={`${form.status === 6 || form.status === "Cancelled"? "text-danger fw-semibold" :
                       form.status === "Trip Started"?"text-primary fw-semibold" :
                     form.status === "Trip Reached"?"text-primary fw-semibold" :
                     form.status === "Delivered"? "text-success" :""}`}
                  value={form.status === 6 || form.status === "Cancelled"? "Cancelled" :
                     form.status === "Trip Reached"? "Ongoing" :
                      form.status === "Trip Started"? "Ongoing" :
                     form.status === "Delivered"? "Completed":""}
                  //   value={form.balance_amount}
                  //   onChange={(e) => handleChange("mobile", e.target.value)}
                  readOnly={!isEdit}
                />
              </div>

              )}

              {
                tabNamee === "Cancelled" && ( 
              <div className="form-groups">
        <label>Cancelled Date & Time</label>
         <input
              type="text"
              value={formatDateTime(form.cancelled_at)}
              onChange={(e) => handleChange("email", e.target.value)}
              readOnly={!isEdit}
            />
        
      </div>
      )
              }
  

            

        </div>

        {/* Row 8 */}
        {
           (step === 5 ) && (
            <div className=" form-groups">
              <label className="text-danger mt-4">Cancel Reason</label>
              <textarea
                rows={3}
                //   type="textbox"
                className=""

                value={form.cancelled_reason}
                //   onChange={(e) => handleChange("mobile", e.target.value)}
                readOnly={!isEdit}
              />
            </div>
          )}

        {/* Buttons */}
        <div className="admin-actions ">
          {/* {type === "view" && !isEdit && ( */}
          {
           (step !== 3 && step !== 5 && step !==4) && (
              <>
                <button
                  onClick={() => setPopup(true)}
                  //  onClick={() => setIsEdit(true)}
                  className="edit-btn">
                  Cancel Trip
                </button>

                {/* )} */}

                {/* {( type === "add" || isEdit) && ( */}
                <button
                  onClick={() => navigation("/booking-assign",
                    {
                      state: {
                        data: data,
                        type: 'edit',
                      }
                    }
                  )}
                  className="save-btn"
                >
                  {tabNamee === "Assigned" ? "Next" : "Assign Trip"}
                </button>

            

              </>
            )

          }

          { 
              (  step === 3 || step ===4) && (
           
                 <button
                  onClick={() => navigation("/booking-assign",
                    {
                      state: {
                        data: data,
                        type: 'edit',
                      }
                    }
                  )}
                  className="resolve-btn"
                >
                  Next
                </button>
                )
                 }

          {/* )} */}
        </div>
      </div>

      {/* User Switch Confirmation Popup */}
      {popup && (
        <div className="delete-modal-overlay">
          <div className="delete-modal-content">
            {/* <h2 className="f4 mt-4 text-center" style={{ color: "#DE3C1E" }}>
               Trip cancellation
            </h2> */}
            {/* <p className="f3 mt-4 text-center" style={{ color: "#0e0d0d" }}>
             You're changing [Vikram] from <br/> 
             Normal User to Special User.
            </p> */}
            <h3 className="delete-modal-title"
            //  style={{ color: "#0e0d0d" }}
            >

              Trip Cancellation
            </h3>
            <p className="delete-modal-message">Are u sure to cancel Trip?</p>
            <div className="d-flex justify-content-center mb-4">
              <textarea
                type="text"
                className="textarea-style"
                value={form.reason}
                onChange={(e) => handleChange("reason", e.target.value)}
              //   readOnly={!isEdit}
              />
            </div>
            <div className="delete-modal-actions">
              <button
                onClick={() => setPopup(false)}
                className="delete-btn-cancel w-40"
              >
                Cancel
              </button>
              <button
                // onClick={() => handleLogout(usertype)}
                onClick={() => canceltrip()}
                className="delete-btn-confirm  f2 w-40"
              >
                {isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                      style={{ color: "white", padding: 8 }}
                    ></span>
                  </>
                ) : (
                  "Confirm"
                  
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingRequest;
